import { useEffect, useState, useCallback } from 'react'
import { PageLoader } from '@/components/auth/PageLoader'

interface LoadingScreenProps {
  onDone: () => void
  duration?: number
}

/**
 * Post-login transition screen — shows PageLoader for `duration` ms
 * then fades out and calls onDone.
 */
export function LoadingScreen({ onDone, duration = 1800 }: LoadingScreenProps) {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), duration - 300)
    return () => clearTimeout(t)
  }, [duration])

  const handleFadeEnd = useCallback(() => {
    if (!visible) onDone()
  }, [visible, onDone])

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        pointerEvents: visible ? 'auto' : 'none',
      }}
      onTransitionEnd={handleFadeEnd}
    >
      <PageLoader />
    </div>
  )
}
